/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

// export default (router) => {
//     router(`/dashboard/roam`, controller.roam, makeLayout, render);
// };


export default (router) => {
    router(`/dashboard/roam`, controller.plan, makeLayout, render);
    router(`/dashboard/roam/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/roam/subscribe`, controller.newPlan, makeLayout, render);
};